import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import PropTypes from 'prop-types';

function StrategyExportButton({ tableHeight, onExport, children }) {
  const [exporting, setExporting] = useState(false);

  return (
    <LoadingButton
      color="success"
      loading={exporting}
      loadingPosition="end"
      endIcon={<SimCardDownloadOutlinedIcon />}
      variant="contained"
      size="small"
      onClick={async () => {
        let scale =
          window.innerWidth /
          document.getElementsByClassName('strategy_table')[0].scrollWidth;
        document.getElementsByClassName(
          'strategy_table',
        )[0].style.transform = `scale(${scale})`;
        document.getElementsByClassName('strategy_table')[0].style.width = `${
          document.getElementsByClassName('strategy_table')[0].scrollWidth
        }px`;
        document.getElementsByClassName(
          'strategy_table',
        )[0].style.maxHeight = `${
          document.getElementsByClassName('strategy_table')[0].scrollHeight
        }px`;

        setExporting(true);
        setTimeout(async () => {
          await onExport();
          document.getElementsByClassName('strategy_table')[0].style.transform =
            'scale(1)';
          document.getElementsByClassName(
            'strategy_table',
          )[0].style.width = `${window.innerWidth}px`;
          document.getElementsByClassName(
            'strategy_table',
          )[0].style.maxHeight = `${tableHeight}px`;
          setExporting(false);
        }, 1000);
      }}
    >
      <span>{exporting ? 'Exporting' : children}</span>
    </LoadingButton>
  );
}

StrategyExportButton.propTypes = {
  tableHeight: PropTypes.number.isRequired,
  onExport: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
};

export default StrategyExportButton;
